module.exports = __webpack_public_path__ + "assets/img/sdaszx.c67ed691.png";